import { generatePath } from 'react-router-dom'
import { ROUTES } from '../routes'

export const getEntityLink = (entityType, entityId) => {
  switch (entityType) {
    case 'Ticket':
      return generatePath(ROUTES.ticket, { id: entityId })
    case 'Job':
    default:
      return generatePath(ROUTES.job, { id: entityId })
  }
}
